module.exports = __webpack_public_path__ + "img/dicoding-0.6112f6fa.png";